import React, { useEffect } from "react";
import "./Css/AboutUS.css";
const Aboutus = () => {
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: "59", behavior: "smooth" });
    }, 100);
  }, []);
  return (
    <div className="about-us">
      <h1>About Us</h1>
      <h1>Welcome to htmlgames4u.com</h1>

      <p>
        Welcome to domainplaynplaygames.com, an exciting and educational new
        game world for kids. Our website is built to provide children with games
        developed using HTML and Flash technologies. Our developers have several
        years of experience in the game development industry and have created
        games for major platforms such as HTML5, iOS, and Android.
      </p>

      <p>
        Our website features a wide range of interactive online games designed
        specifically for kids, with brightly colored effects that keep them
        entertained. We also offer games that parents can enjoy playing together
        with their children.
      </p>

      <p>
        We mainly develop HTML5 games suitable for kids. These include makeover,
        dress-up, princess, cooking, puzzle, and similar games. Each game is
        designed to help children learn essential skills required for their
        daily life activities.
      </p>

      <p>
        We continuously strive to deliver engaging and educational baby games
        that allow parents to teach life skills to their kids in an enjoyable
        way. Our free online games are simple to play, fun, and exciting, making
        learning a joyful experience for children.
      </p>

      <p>
        Interestingly, our games are designed to be enjoyable and educational
        for all age groups. Regardless of age, everyone can play and learn from
        our games. Many adults also enjoy spending their leisure time pleasantly
        by playing these games.
      </p>

      <p>
        Our aim is to provide optimally educational and challenging games that
        offer an enjoyable and rewarding experience to our users. The games on
        our website are carefully designed to suit all age groups and different
        gaming preferences.
      </p>

      <p>
        We are not one-time developers. We continuously improve our skills and
        plan to add more exciting and educational games for kids, moms, and
        teens.
      </p>

      <p>
        Your child's safety is as important to us as it is to you. Our games are
        reviewed by a team of experts and are declared safe for kids as well as
        other age groups.
      </p>

      <p>
        Our games are an innovative way to teach and learn essential skills. At
        domainplaynplaygames.com, you can learn a lot while having fun.
      </p>

      <p>
        Our vision is a world where kids do not have to learn new skills in a
        boring or exhausting way. We imagine a world where learning happens
        naturally through fun and play.
      </p>
    </div>
  );
};
export default Aboutus;
